import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import {formValueSelector} from "redux-form/immutable";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./ShippingAddressForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelNewSubscriptionShippingAddress} from "../../actions/AccountApiActions";
import {fromJS, List} from "immutable";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";
import {getUSStates, getCanadaProvinces, isUS, isCanada} from "../../lib/CountriesAndStates";
import {hasStateProvince} from "../../lib/AddressRules";
import {validateShippingAddress} from "../../lib/AddressValidation";
import {coerceBoolean} from "../../components/forms/BooleanInputField";

function validateForm(values, props) {
  return validateShippingAddress(values).toJS();
}

class NewShippingAddressFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("accountId", this.props.accountId)
                              .set("subscriptionId", this.props.subscriptionId)
                              .set("skipAddressValidation", coerceBoolean(values.get("skipAddressValidation")))
                              .delete("addressCountryName");
    
    return this.props.changeSubscriptionShippingAddress(updatedValues.toJS())
      .then((response) => {
        if (response.data.changeSubscriptionShippingAddress.errors.length <= 0) {
          this.props.cancelNewSubscriptionShippingAddress();
        } else {
          let errors = createValidationErrors(response.data.changeSubscriptionShippingAddress.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelNewSubscriptionShippingAddress();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let countries = fromJS(data.availableCountriesForAccount);
    let currentAddress = fromJS(data.subscriptionInfo.shippingAddress);
    const initialValues = currentAddress.delete("__typename");
    let stateProvinces = List([]);
    if (this.props.showUSStates) stateProvinces = getUSStates();
    if (this.props.showCanadaProvinces) stateProvinces = getCanadaProvinces();

    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        countries={countries}
        stateProvinces={stateProvinces}
        showAttentionName={true}
        showPhoneNr={true}
        showEmail={true}
        showStateProvince={this.props.showStateProvince}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const CHANGE_SHIPPING_ADDRESS = gql`
  mutation changeSubscriptionShippingAddress($data: SubscriptionShippingAddressInput!) {
    changeSubscriptionShippingAddress(input: $data) {
      errors { key message }
    }
  }
`;

const ADDRESS_INFO = gql`
  query templateAddressInfo($accountId:ID!, $subscriptionId:ID!) {
    subscriptionInfo(subscriptionId: $subscriptionId) {
      shippingAddress {
        type
        name
        attName
        phoneNr
        email
        addressAddressLine1
        addressAddressLine2
        addressCity
        addressPostcode
        addressStateProvince
        addressCountryName
        addressCountryCode
      }
    }
    availableCountriesForAccount(accountId:$accountId) {
      kind
      code
      name
      availability
    }
  }
`;

const withAddressQuery = compose(
  graphql(ADDRESS_INFO, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        accountId: props.accountId,
        subscriptionId: props.subscriptionId
      }
    })
  }),
  graphql(CHANGE_SHIPPING_ADDRESS, {
    props: ({ mutate }) => ({
      changeSubscriptionShippingAddress: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

const NewShippingAddressFormContainerWithData = withAddressQuery(NewShippingAddressFormContainer);

const selector = formValueSelector("ShippingAddressForm");
function mapStateToProps(state, ownProps) {
  return {
    showUSStates: isUS(selector(state, "addressCountryCode")),
    showCanadaProvinces: isCanada(selector(state, "addressCountryCode")),
    showStateProvince: hasStateProvince(selector(state, "addressCountryCode"))
  }
}

export default connect(mapStateToProps, {cancelNewSubscriptionShippingAddress})(NewShippingAddressFormContainerWithData);